import React, { useEffect, useState } from "react";
import "./agentstable.css";
import CompanyDashboard from "../../companies/CompanyDashboard";
import { Table, Dropdown, Menu, message } from "antd";
import { useNavigate } from "react-router-dom";
import { BsThreeDots } from "react-icons/bs";
import { FaPlus } from "react-icons/fa6";
import AddAgentModal from "../../agents page/agent modal/AddAgentModal";
import ViewAgentModal from "../../agents page/view agent modal/ViewAgentModal";
import EditAgentModal from "../../agents page/edit modal/EditAgentModal";
import AgentDeleteModal from "../../agents page/deletemodal/AgentDeleteModal";

import { Modal } from "react-bootstrap";
import Instance from "../../../AxiosConfig";

const AgentsTable = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const itemsPerPage = 10;
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const handleModalClick = (key, record) => {
    setSelectedData(record); // store selected agent

    if (key === "view") {
      setShowViewModal(true);
    } else if (key === "edit") {
      setShowEditModal(true);
    } else if (key === "delete") {
      setShowDelete(true);
    }
  };

  const menu = (record) => (
    <Menu
      onClick={({ key }) => handleModalClick(key, record)} // pass record here too
      className="custom-dropdown-menu"
    >
      <Menu.Item key="view">View</Menu.Item>
      <Menu.Item key="edit">Edit</Menu.Item>
      <Menu.Item key="delete">Delete</Menu.Item>
    </Menu>
  );

  const fetchData = async (page = 1) => {
    setLoading(true);
    // const token = localStorage.getItem("token");
    try {
      const response = await Instance.get("/agents", {
        params: { page, limit: itemsPerPage },
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // },
      });
      console.log(response);
      if (response.status == 200 || response.status == 201) {
        setData(response?.data?.agents);
      }
    } catch (error) {
      console.log(error.response);
    }finally{
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      title: "Agent Name",
      dataIndex: "agentName",
    },
    {
      title: "Assigned Companies",
      dataIndex: "companyCount",
    },
    {
      title: "Email",
      dataIndex: "agentEmail",
    },
    {
      title: "Mobile Number",
      dataIndex: "agentNumber",
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   render: (text) => {
    //     const statusClass = text.toLowerCase().replace(/\s/g, "");
    //     return <span className={`status-badge ${statusClass}`}>{text}</span>;
    //   },
    // },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Dropdown
          overlay={menu(record)} // pass record here
          trigger={["click"]}
          placement="bottomRight"
        >
          <BsThreeDots style={{ fontSize: "20px", cursor: "pointer" }} />
        </Dropdown>
      ),
    },
  ];

  // const data = [
  //   {
  //     key: "1",
  //     agentid: "Levon techno",
  //     agentname: "IT Services",
  //     assignedcompanies: "2025-12-20",
  //     email: "levon@gmail.com",
  //     mobilenumber: "1234567890",
  //     status: "active",
  //   },
  //   {
  //     key: "2",
  //     agentid: "Wipro",
  //     agentname: "IT Services",
  //     assignedcompanies: "2025-12-15",
  //     email: "vardhan@gmail.com",
  //     mobilenumber: "1234567891",
  //     status: "in active",
  //   },
  //   {
  //     key: "3",
  //     agentid: "tech mahindra",
  //     agentname: "IT Services",
  //     assignedcompanies: "2022-12-20",
  //     email: "email@gmail.com",
  //     mobilenumber: "1234567892",
  //     status: "active",
  //   },
  //   {
  //     key: "4",
  //     agentid: "Tcs",
  //     agentname: "IT Services",
  //     assignedcompanies: "2020-12-20",
  //     email: "jio@gmail.com",
  //     mobilenumber: "1234567893",
  //     status: "in active",
  //   },
  // ];

  return (
    <div>
      {/* <CompanyDashboard /> */}
      <div className="agents-page mt-5">
        <div className="agents-table mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="agents-heading-h1">Agents List</h1>
            <div className="d-flex align-items-center gap-3 table-header-buttons">
              <button className="surve-export-btn" onClick={handleShow}>
                <FaPlus /> Add New Agent
              </button>
            </div>
          </div>
          <div className="mt-4">
            <Table
              columns={columns}
              dataSource={data}
              loading={loading}
              pagination={{
                pageSize: itemsPerPage,
                current: currentPage,
                onChange: (page) => setCurrentPage(page),
                className: "custom-pagination",
              }}
              scroll={{ x: "max-content" }}
            />
          </div>
        </div>
      </div>
      <AddAgentModal show={showModal} handleClose={handleClose} fetchData={fetchData}
/>
      <ViewAgentModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        agentData={selectedData}

      />
      <EditAgentModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        agentData={selectedData}
                fetchData={fetchData}

      />
      <AgentDeleteModal
        show={showDelete}
        onClose={() => setShowDelete(false)}
        agentData={selectedData}
        fetchData={fetchData}
      />
    </div>
  );
};

export default AgentsTable;
